/**
* Login container
*
* @author Ritesh Shrivastav
* @author Akhila
*/
import GuestPage from '../components/GuestPage'
import HeadManager from '../components/HeadManager';
import LoginForm from '../components/LoginForm';
import PropTypes from 'prop-types';
import React from 'react';
import TaghashIllustration from '../assets/Taghash_Illustration_02.png';
import { decodeNext } from '../helpers/string/nextPath';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { login, loadUser, fetchGoogleSettingsForLogin, fetchMicrosoftSettingsForLogin } from '../modules/auth';

class Login extends React.Component {
  static propTypes = {
    fetchGoogleSettingsForLogin: PropTypes.func.isRequired,
    googleSettingsForLoginLoading: PropTypes.bool.isRequired,
    googleSettingsForLoginError: PropTypes.string,

    fetchMicrosoftSettingsForLogin: PropTypes.func.isRequired,
    microsoftSettingsForLoginLoading: PropTypes.bool.isRequired,
    microsoftSettingsForLoginError: PropTypes.string,

    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    login: PropTypes.func.isRequired,
    loginLoading: PropTypes.bool.isRequired,
    loginError: PropTypes.string,
    me: PropTypes.object,
  };

  componentDidMount() {
    const { loadUser } = this.props;
    loadUser()
    .catch((err) => {});
  }

  componentDidUpdate() {
    const { me, history, location } = this.props;
    if (me) {
      const params = new URLSearchParams(location.search);
      const nextPath = (params.get('next') ? decodeNext(params.get('next')) : '/dashboard');
      history.push(nextPath);
    }
  }

  render() {
    const { login, loginLoading, loginError, location } = this.props;
    const { 
      googleSettingsForLoginLoading,
      googleSettingsForLoginError,
      microsoftSettingsForLoginLoading,
      microsoftSettingsForLoginError 
    } = this.props;

    const { fetchGoogleSettingsForLogin,fetchMicrosoftSettingsForLogin } = this.props;
    return (
      <div>
        <HeadManager title="Login" />
        <GuestPage
        left={
          <LoginForm
            fetchGoogleSettingsForLogin={fetchGoogleSettingsForLogin}
            googleSettingsForLoginLoading={googleSettingsForLoginLoading}
            googleSettingsForLoginError={googleSettingsForLoginError}
            fetchMicrosoftSettingsForLogin={fetchMicrosoftSettingsForLogin}
            microsoftSettingsForLoginLoading={microsoftSettingsForLoginLoading}
            microsoftSettingsForLoginError={microsoftSettingsForLoginError}
            location={location}
            login={login}
            loginLoading={loginLoading}
            loginError={loginError}
          />
        }
        right={
          <img
            src={TaghashIllustration}
            alt="Taghash"
            width="100%"
          />
        }
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  me: state.auth.user,
  googleSettingsForLoginLoading: state.auth.googleSettingsForLoginLoading,
  googleSettingsForLoginError: state.auth.googleSettingsForLoginError,
  microsoftSettingsForLoginLoading: state.auth.microsoftSettingsForLoginLoading,
  microsoftSettingsForLoginError: state.auth.microsoftSettingsForLoginError,
  loginLoading: state.auth.loginLoading,
  loginError: state.auth.loginError,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  login,
  loadUser,
  fetchGoogleSettingsForLogin,
  fetchMicrosoftSettingsForLogin,
}, dispatch);

//
// https://github.com/ReactTraining/react-router/issues/4756
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
